import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Field } from 'redux-form';
import ReactDOM from 'react-dom';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { InputField, DisabledInputField } from '../../components/Common/inputField';
import moment from 'moment';

class logModal extends Component {
    constructor() {
      super();
      this.state = {
        report: {
          rows: [{}],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
      };
    }

    componentWillMount() {
      let sessionsProps = this.props.rowProps.SessionLogs;
      for (let i = 0; i < sessionsProps.length; i++) {
        let date = new Date(sessionsProps[i].LogInTime);
        let formattedDate = date.getFullYear() + '-';
        formattedDate += date.getMonth()+1 + '-';
        if (date.getDate() < 10) {
          formattedDate += '0' + date.getDate();
        } else {
          formattedDate += date.getDate();
        }
        let LogInTime = '';
        if(sessionsProps[i].LogInTime){
          LogInTime = moment.utc(sessionsProps[i].LogInTime).local().format('LT');
          // LogInTime = sessionsProps[i].LogInTime;
          // LogInTime = LogInTime.substring(LogInTime.indexOf('T') + 1, LogInTime.indexOf('T') + 6);
        }
        let LogOutTime = '';
        if(sessionsProps[i].LogOutTime){
          LogOutTime = moment.utc(sessionsProps[i].LogOutTime).local().format('LT');
          // LogOutTime = sessionsProps[i].LogOutTime;
          // LogOutTime = LogOutTime.substring(LogOutTime.indexOf('T') + 1, LogOutTime.indexOf('T') + 6);
        }
        sessionsProps[i].Date = formattedDate;
        sessionsProps[i].NewLogInTime = LogInTime;
        sessionsProps[i].NewLogOutTime = LogOutTime;
      }
      this.setState({ report: { rows: sessionsProps } });
    }

    componentWillReceiveProps(nextProps) {
      let sessionsProps = nextProps.rowProps.SessionLogs;
      for (let i = 0; i < sessionsProps.length; i++) {
        let date = new Date(sessionsProps[i].LogInTime);
        let formattedDate = date.getFullYear() + '-';
        formattedDate += date.getMonth()+1 + '-';
        if (date.getDate() < 10) {
          formattedDate += '0' + date.getDate();
        } else {
          formattedDate += date.getDate();
        }
        let LogInTime = sessionsProps[i].LogInTime;
        LogInTime = LogInTime.substring(LogInTime.indexOf('T') + 1, LogInTime.indexOf('T') + 6);
        let LogOutTime = sessionsProps[i].LogOutTime;
        LogOutTime = LogOutTime.substring(LogOutTime.indexOf('T') + 1, LogOutTime.indexOf('T') + 6);
        sessionsProps[i].Date = formattedDate;
        sessionsProps[i].NewLogInTime = LogInTime;
        sessionsProps[i].NewLogOutTime = LogOutTime;
      }
      this.setState({ report: { rows: sessionsProps } });
    }

    renderTable() {
      let tableHeight = (window.innerHeight < 930) ? 300 : 330;

      const getRows = () => {
          return Data.Selectors.getRows(this.state.report);
      }

      const getSize = () => {
          return getRows().length;
      }

      const rowGetter = rowIdx => {
          var rows = getRows();
          return rows[rowIdx];
      }

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
          var state = Object.assign({}, this.state.report, { sortColumn: sortColumn, sortDirection: sortDirection });
          this.setState({report: state});
      }

      const handleFilterChange = filter => {
          let newFilters = Object.assign({}, this.state.report.filters);
          if (filter.filterTerm) {
              newFilters[filter.column.key] = filter;
          } else {
              delete newFilters[filter.column.key];
          }
          var report = {...this.state.report, filters: newFilters};
          this.setState({ report });
      }

      const handleRowUpdated = e => {
          const rows = getRows();
          Object.assign(rows[e.rowIdx], e.updated);
          const report = { ...this.state.report, rows }
          this.setState({ report });
      }

      // Handle the row select function

      const onRowSelect = rows => {
          var report = {...this.state.report, selectedRows: rows};
          this.setState({ report });
      }
      const columns = [
        {
            key: 'SessionLog_id',
            name: <Translate value="id" />,
            width: 25,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'User',
            name: <Translate value="user" />,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'Date',
            name: <Translate value="date" />,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'NewLogInTime',
            name: <Translate value="login" />,
            width: 80,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'NewLogOutTime',
            name: <Translate value="logout" />,
            width: 80,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'StartingCash',
            name: <Translate value="cash_in" />,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'TotalCashAmount',
            name: <Translate value="end_cash" />,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'StoreCredit',
            name: <Translate value="store_credit" />,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'Checks',
            name: <Translate value="check" />,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'CreditCards',
            name: <Translate value="card" />,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'TotalSale',
            name: <Translate value="total_sale" />,
            resizable: true,
            sortable: true,
            editable: true,
        },
        {
            key: 'TotalPaidOut',
            name: <Translate value="paid_out" />,
            resizable: true,
            sortable: true,
            editable: true,
        },
      ];

      return (
          <Row>
            <Col xs={ 12 }>
              <div id="LogModal-dataGrid1">
                <ReactDataGrid
                  onGridSort={handleGridSort}
                  onAddFilter={handleFilterChange}
                  columns={columns}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  rowHeight={25}
                  headerRowHeight={45}
                  minHeight={tableHeight}
                  onRowUpdated={handleRowUpdated}
                  onRowSelect={onRowSelect} />
              </div>
            </Col>
          </Row>
      )
  }

    render() {
      return (
        <ContentWrapper>
          <div>
            {this.renderTable()}
          </div>
        </ContentWrapper>
      )
    }
}

export default logModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/logModal.jsx